module.exports = __webpack_public_path__ + "static/media/ttgr_thumb_home.9e667880.mp4";